// Reference images (2B) for the PDF. react-pdf renders in the browser, so
// each image is fetched through this page's gated route (admin or client
// link) and handed over as a data URL before render. Stored images are JPEG,
// which react-pdf decodes reliably.

import { collectRefImageIds } from '../../shared/refImages';
import { refImageUrl } from './refImageSource';

async function toDataUrl(blob: Blob): Promise<string> {
  const bytes = new Uint8Array(await blob.arrayBuffer());
  let binary = '';
  for (let i = 0; i < bytes.length; i += 0x8000) {
    binary += String.fromCharCode(...bytes.subarray(i, i + 0x8000));
  }
  return `data:${blob.type || 'image/jpeg'};base64,${btoa(binary)}`;
}

/** Image id to data URL, or null where the fetch failed ("Image unavailable"). */
export async function loadPdfImages(doc: unknown): Promise<Map<string, string | null>> {
  const ids = collectRefImageIds(doc);
  const entries = await Promise.all(
    ids.map(async (id): Promise<[string, string | null]> => {
      const url = refImageUrl(id);
      if (!url) return [id, null];
      try {
        const res = await fetch(url, { credentials: 'same-origin' });
        if (!res.ok) return [id, null];
        return [id, await toDataUrl(await res.blob())];
      } catch {
        return [id, null];
      }
    }),
  );
  return new Map(entries);
}
